import React, {FunctionComponent, useContext} from 'react';
import {DefaultTheme, ThemeProvider} from 'styled-components';

import {convertDate, convertToIsoStringTimezoneOffset} from '~/src/utilities/helpers/date';
import {DateAndTimeFormat} from '~/src/utilities/constants/formats';
import {SettingsContext} from '~/src/components/context/SettingsContext';
import {getThemes} from '~/src/utilities/helpers/brand';
import {SiteArea} from '~/src/utilities/constants/navigation';

import {PublishDate as DsPublishDate} from '@components/atoms/publish-date';

type Props = {
    publishedTime: string;
    isUpdated: boolean;
};

const Themes = getThemes();
const PassThrough = (theme: DefaultTheme) => theme;

const getTheme = (siteArea: string) => {
    switch (siteArea) {
        case SiteArea.VIDEO:
            return Themes.Video;
        case SiteArea.LIFESTYLE:
            return Themes.LifestyleAlternative;
        default:
            return PassThrough;
    }
};

const PublishDate: FunctionComponent<Props> = ({publishedTime, isUpdated}) => {
    const settings = useContext(SettingsContext);

    return (
        <ThemeProvider theme={getTheme(settings.siteArea)}>
            <DsPublishDate
                publishedTime={convertToIsoStringTimezoneOffset(publishedTime)}
                formattedPublishedTime={convertDate(publishedTime, DateAndTimeFormat)}
                isUpdated={isUpdated}
            />
        </ThemeProvider>
    );
};

export default PublishDate;
